import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RippleModule } from 'primeng/ripple';

import { MarkdownEditorModule } from '../../components/markdown-editor/markdown-editor.module';
import { AccountFaqComponent } from './account-faq.component';

@NgModule({
  declarations: [AccountFaqComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DynamicDialogModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    MarkdownEditorModule,
    RippleModule,
  ],
  exports: [AccountFaqComponent],
})
export class AccountFaqModule {}
